// extracted by mini-css-extract-plugin
export default {"border":"HealthStatus_border__3K1CP","red":"HealthStatus_red__dm1Ua","yellow":"HealthStatus_yellow__WAtWV","lgreen":"HealthStatus_lgreen__VhVvY","green":"HealthStatus_green__xoBKG"};